import { render, staticRenderFns } from "./user_kjcy.vue?vue&type=template&id=7970eafa&"
import script from "./user_kjcy.vue?vue&type=script&lang=js&"
export * from "./user_kjcy.vue?vue&type=script&lang=js&"
import style0 from "./user_kjcy.vue?vue&type=style&index=0&id=7970eafa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports